export const getFlag = (country_code) => {
    if (!country_code) {
        return
    }

    return `https://flagcdn.com/${country_code.toLowerCase()}.svg`
}